import React from 'react';
import classNames from 'classnames';

import {frontend} from 'pageflow-scrolled/frontend';

import styles from './donateButton.module.css';

frontend.widgetTypes.register('donateButton', {
  component: function Footer({configuration, navigationExpanded}) {
    const targetAttributes = configuration.openInNewTab || inEditor() ?
                             {target: '_blank', rel: 'noopener noreferrer'} :
                             {};
    return (
      <div className={classNames(
        styles.bar,
        {[styles.expanded]: navigationExpanded
      })}>
        <a className={styles.button}
           href={configuration.url}
           {...targetAttributes}>
          {configuration.label || 'Donate'}
        </a>
      </div>
    );
  }
});

function inEditor() {
  return (typeof window !== 'undefined') &&
         window.location.pathname.indexOf('/editor/entries') === 0;
}
